// Cliente del BI de universidades (Futuria). Pega a Django vía el proxy
// /django-api con el JWT del admin (org sale del JWT → cada org ve su data).
import type { UniItem, Overview, Curriculum } from './types';

const DJANGO = '/django-api';
const BASE = '/api/v1/futuria/bi';

function headers(): Record<string, string> {
  const t = localStorage.getItem('auth_token');
  return { Authorization: `Bearer ${t ?? ''}` };
}
async function j<T>(res: Response): Promise<T> {
  if (!res.ok) throw new Error(`${res.status} ${res.statusText} — ${(await res.text()).slice(0, 200)}`);
  return res.json() as Promise<T>;
}

export async function getUniversidades(): Promise<UniItem[]> {
  const r = await fetch(`${DJANGO}${BASE}/universidades`, { headers: headers() });
  const d = await j<{ universidades: UniItem[] }>(r);
  return d.universidades ?? [];
}
export async function getOverview(universidad?: string): Promise<Overview> {
  const q = universidad ? `?universidad=${encodeURIComponent(universidad)}` : '';
  return j<Overview>(await fetch(`${DJANGO}${BASE}/overview${q}`, { headers: headers() }));
}
export async function getCurriculum(universidad: string): Promise<Curriculum> {
  return j<Curriculum>(await fetch(`${DJANGO}${BASE}/curriculum?universidad=${encodeURIComponent(universidad)}`, { headers: headers() }));
}
